import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { IconRenderer, Dialog, Stack, Inline, IconPersonVerified, Text, IconDate, IconHash, Heading, Link, ButtonIcon, Rating, TextLink } from "braid-design-system";
import { useState } from "react";
import { useJobDetailsViewContext, CompanyName, useAnalyticsHandlers } from "../CompanyName/CompanyName.mjs";
import { useJobUrl, jobUrlOriginValues } from "../JDVLayout/JDVLayout.mjs";
import { translations } from "../../../components/.vocab/index.mjs";
import { translations as translations$1 } from "../../../components/JobDetailsViewHeader/.vocab/index.mjs";
import { hoverLink } from "../JobDetailsView/JobDetailsView.css.mjs";
const IconVerifiedTrust = () => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className,
    fill: "currentColor",
    children: [
      /* @__PURE__ */ jsx("path", { d: "m20.352 4.063-8-3a1.013 1.013 0 0 0-.704 0l-8 3A1 1 0 0 0 3 5v7c0 6.543 8.203 10.72 8.553 10.895a1 1 0 0 0 .894 0C12.797 22.72 21 18.543 21 12V5a1 1 0 0 0-.648-.937Zm-8.353 16.8c-.774-.44-2.421-1.46-3.924-2.9A2.978 2.978 0 0 1 11 15.5h2a2.978 2.978 0 0 1 2.924 2.457c-1.503 1.442-3.151 2.465-3.925 2.905ZM19 12c0 1.57-.652 3-1.564 4.243A4.968 4.968 0 0 0 13 13.5h-2a4.968 4.968 0 0 0-4.439 2.747C5.651 15.004 5 13.573 5 12V5.693l7-2.625 7 2.625V12Z" }),
      /* @__PURE__ */ jsx("path", { d: "M8.563 8.5c0 1.896 1.541 3.438 3.437 3.438s3.438-1.542 3.438-3.438S13.896 5.062 12 5.062 8.562 6.604 8.562 8.5Zm5 0c0 .861-.702 1.563-1.563 1.563S10.437 9.36 10.437 8.5 11.14 6.937 12 6.937s1.563.702 1.563 1.563Z" })
    ]
  }
) }) });
const VerifiedHirerInfo = ({ open, closeFn }) => {
  const { t } = useTranslations(translations);
  const {
    job: {
      company: { tags, registrationDate, verifiedBy }
    }
  } = useJobDetailsViewContext();
  const brandName = verifiedBy || "SEEK";
  const verificationInfo = t(
    `Review and verified by brand's trust & safety team`,
    { brand: brandName }
  );
  const registrationYear = registrationDate && new Date(registrationDate).getFullYear() || null;
  const registrationDateInfo = registrationYear ? t("Joined brand in year", {
    brand: brandName,
    year: registrationYear.toString()
  }) : null;
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      id: "dlg-verified-hirer-info",
      title: t("Verifications"),
      onClose: closeFn,
      open,
      width: "small",
      children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
        /* @__PURE__ */ jsxs(Inline, { space: "xxsmall", alignY: "center", children: [
          /* @__PURE__ */ jsx(CompanyName, {}),
          /* @__PURE__ */ jsx(IconPersonVerified, { size: "small" })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
          verificationInfo ? /* @__PURE__ */ jsx(Text, { size: "small", icon: /* @__PURE__ */ jsx(IconVerifiedTrust, {}), children: verificationInfo }) : null,
          registrationDateInfo ? /* @__PURE__ */ jsx(Text, { size: "small", icon: /* @__PURE__ */ jsx(IconDate, {}), children: registrationDateInfo }) : null,
          tags && tags.length > 0 ? tags.map(({ key, value }, index) => /* @__PURE__ */ jsxs(Text, { size: "small", icon: /* @__PURE__ */ jsx(IconHash, {}), children: [
            key,
            " ",
            value
          ] }, `tag-${index}`)) : null
        ] })
      ] })
    }
  );
};
const JobTitle = () => {
  const {
    hideJobLink,
    job,
    jobUrlOpts,
    renderRelativePaths,
    onAnalyticsEvent
  } = useJobDetailsViewContext();
  const url = useJobUrl({
    id: job.id,
    jobUrlOpts,
    renderRelativePaths,
    overrideValues: {
      origin: jobUrlOriginValues.jobTitle
    }
  });
  const jobUrl = job.url || url;
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  return /* @__PURE__ */ jsx(Heading, { level: "3", component: "h1", data: { automation: "job-detail-title" }, children: hideJobLink ? job.title : /* @__PURE__ */ jsx(
    Link,
    {
      href: jobUrl,
      onClick: analytics.onJobTitleClick,
      className: hoverLink,
      target: "_blank",
      children: job.title
    }
  ) });
};
const VerifiedHirerName = ({
  trackVerifiedHirerBadgeClick
}) => {
  const { t } = useTranslations(translations$1);
  const [showVerificationInfo, setShowVerificationInfo] = useState(false);
  const {
    job: {
      company: { name, isVerified }
    }
  } = useJobDetailsViewContext();
  return isVerified ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Inline, { space: "xxsmall", alignY: "center", children: [
      /* @__PURE__ */ jsx(
        Text,
        {
          data: { automation: "advertiser-name" },
          size: "standard",
          weight: "regular",
          tone: "neutral",
          children: name
        }
      ),
      /* @__PURE__ */ jsx(
        ButtonIcon,
        {
          id: "ico-verified-hirer-badge",
          label: t("Verifications"),
          variant: "transparent",
          icon: /* @__PURE__ */ jsx(IconPersonVerified, {}),
          size: "small",
          onClick: () => {
            trackVerifiedHirerBadgeClick();
            setShowVerificationInfo(true);
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      VerifiedHirerInfo,
      {
        open: showVerificationInfo,
        closeFn: () => setShowVerificationInfo(false)
      }
    )
  ] }) : /* @__PURE__ */ jsx(Text, { data: { automation: "advertiser-name" }, children: name });
};
const CompanyLinks = () => {
  const {
    job: { company: { reviews, jobsSearchUrl } = {} },
    onAnalyticsEvent
  } = useJobDetailsViewContext();
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  const { t } = useTranslations(translations$1);
  if (!reviews && !jobsSearchUrl) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Inline, { space: "xsmall", alignY: "bottom", children: [
    reviews && reviews.count > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Rating,
        {
          size: "small",
          rating: reviews.rating,
          variant: "minimal",
          data: { automation: "company-review" }
        }
      ),
      (reviews == null ? void 0 : reviews.reviewsUrl) && /* @__PURE__ */ jsx(Text, { size: "small", children: /* @__PURE__ */ jsx(
        TextLink,
        {
          href: reviews.reviewsUrl,
          rel: "nofollow",
          weight: "weak",
          "data-automation": "job-header-company-review-link",
          onClick: analytics.onCompanyReviewsClick,
          children: t("{JobCompanyReviewsCount} reviews", {
            JobCompanyReviewsCount: reviews.count.toString()
          })
        }
      ) })
    ] }) : null,
    jobsSearchUrl ? /* @__PURE__ */ jsxs(Fragment, { children: [
      (reviews == null ? void 0 : reviews.count) ? /* @__PURE__ */ jsx(Text, { size: "small", children: "·" }) : null,
      /* @__PURE__ */ jsx(Text, { size: "small", children: /* @__PURE__ */ jsx(
        TextLink,
        {
          href: jobsSearchUrl,
          rel: "nofollow",
          onClick: analytics.onCompanyJobSearchClick,
          "data-automation": "job-details-header-more-jobs",
          weight: "weak",
          children: t("View all jobs")
        }
      ) })
    ] }) : null
  ] });
};
const JobDetailsViewHeader = ({
  trackVerifiedHirerBadgeClick
}) => {
  const { featureFlags } = useJobDetailsViewContext();
  return /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
    /* @__PURE__ */ jsx(JobTitle, {}),
    /* @__PURE__ */ jsxs(Inline, { alignY: "center", space: ["medium", "small"], children: [
      (featureFlags == null ? void 0 : featureFlags.enableVerifiedHirerBadge) ? /* @__PURE__ */ jsx(
        VerifiedHirerName,
        {
          trackVerifiedHirerBadgeClick
        }
      ) : /* @__PURE__ */ jsx(CompanyName, {}),
      /* @__PURE__ */ jsx(CompanyLinks, {})
    ] })
  ] });
};
export {
  JobDetailsViewHeader
};
